import { BREAKPOINTS } from '../config';

const { mqTouch, mqTablet } = BREAKPOINTS;

const elements = document.querySelectorAll('[data-threshold-desktop]');

function getThreshold(el) {
  const w = window.innerWidth;

  if (w > mqTouch) {
    return parseFloat(el.dataset.thresholdDesktop) || 0.4;
  }

  if (w > mqTablet) {
    return parseFloat(el.dataset.thresholdTablet) || 0.3;
  }

  return parseFloat(el.dataset.thresholdMobile) || 0.15;
}

function getSafeThreshold(el, desiredThreshold) {
  const viewportHeight = window.innerHeight;
  const elementHeight = el.offsetHeight;

  if (elementHeight <= viewportHeight) {
    return desiredThreshold;
  }

  const maxPossible = viewportHeight / elementHeight;

  return Math.min(desiredThreshold, maxPossible - 0.05);
}

const observers = new Map();

function observeElement(el) {
  const desiredThreshold = getThreshold(el);
  const threshold = getSafeThreshold(el, desiredThreshold);

  const observer = new IntersectionObserver(
    ([entry], obs) => {
      if (!entry.isIntersecting) return;

      el.classList.add('is-threshold');
      obs.unobserve(el);
    },
    {
      threshold,
    }
  );

  observer.observe(el);
  observers.set(el, observer);
}

elements.forEach(observeElement);

// data-threshold-desktop="0.4"
// data-threshold-tablet="0.3"
// data-threshold-mobile="0.15"
